import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { LoginLogo } from "@/features/auth/components/LoginLogo";

export const RegisterCompletePage: FC = () => {
  const navigate = useNavigate();

  return (
    <Stack width={400} gap={6} alignItems="center">
      <LoginLogo />
      <Stack width="100%" gap={4}>
        <Typography variant="head20Bold" align="center">
          パスワードの登録完了
        </Typography>
        <Stack width="100%" gap={6}>
          <Typography variant="body14" color={text.secondary}>
            パスワードの登録が完了しました。
          </Typography>
          <Button fullWidth size="sm" onClick={() => navigate(AppRoutes.login)}>
            ログイン画面へ
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
